import { createFileRoute } from "@tanstack/react-router";
import { categoryHead } from "@/lib/seo";
import { CategoryHero } from "@/components/CategoryHero";
import { ProductGrid } from "@/components/ProductGrid";
import { useCollectionProducts } from "@/lib/use-catalog";
import { newArrivals, lookProducts, accessories } from "@/lib/catalog";
const bijouxAccessoiresAsset = { url: "/img/bijoux-accessoires.webp" };

export const Route = createFileRoute("/accessoires")({
  head: () =>
    categoryHead({
      path: "/accessoires",
      title: "Foulards & Accessoires Femme au Maroc | SUNSET",
      description:
        "Foulards paisley, bandanas, bijoux et accessoires d'été pour femme. Dès 199 DH, livraison partout au Maroc et paiement à la livraison.",
      socialDescription:
        "Foulards paisley, bandanas et bijoux d'été SUNSET Concept Store. Paiement à la livraison partout au Maroc.",
      name: "Foulards & Accessoires",
      image: "/og/accessoires.jpg",
      imageAlt: "Foulards, bijoux et accessoires d'été Sunset Concept Store",
      products: localProducts,
    }),
  component: AccessoiresPage,
});

const localProducts = [...newArrivals, ...lookProducts, ...accessories].filter(
  (p) => ["Bijoux", "Foulards", "Accessoires"].includes(p.category),
);

function AccessoiresPage() {
  const products = useCollectionProducts("/accessoires", localProducts, /bijou|accessoire|foulard/i);
  return (
    <>
      <CategoryHero
        image={bijouxAccessoiresAsset.url}
        imageAlt="Bijoux, foulards et accessoires d'été Sunset Concept Store"
        eyebrow="Collection"
        title="Bijoux & Accessoires"
        subtitle="Foulards, bijoux et détails précieux pour sublimer vos tenues d'été."
        imagePosition="sm:object-[50%_50%]"
      />
      <ProductGrid
        products={products}
        placeholderCount={8}
        title="Nos Accessoires"
        eyebrow="Nouveautés"
        subtitle="Les finitions qui font toute la différence, des bijoux aux foulards."
        emptyMessage={
          <>
            <p className="text-sm text-muted-foreground sm:text-base">
              La collection Accessoires sera bientôt en ligne.
            </p>
            <p className="label-xs mt-3 text-accent">Revenez très vite</p>
          </>
        }
      />
    </>
  );
}
